import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http'
import { roleStr, roleName, roleInfo } from '../../common/common';
import { deduplicationObjArr, deduplicationObjArr2 } from '../../common/utils';
import { getObjByName } from '../../common/utils';
import userDao from '../../request/userDao';

const Root = styled(Box)({
    '& .textField': {
        width: '45% !important',
        marginRight: '30px',
        backgroundColor: '#FFFFFF',
    },
})

const VIEW = 1;
const EDIT = 2;
const ADMIN = "admin";
const DEPT = "dept_manager";
class LevelChoose extends Component {
    static defaultProps = {
        justTeam: false
    }
    constructor(props) {
        super(props);
        this.state = {
            office: "",
            department_id: "",
            team_id: "",
            member_id: "",

            viewOffice: "",
            viewDept: "",
            viewTeam: "",
            viewMember: "",

            officeData: [],
            departmentsData: [],
            teamsData: [],
            membersData: [],
        }
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            office,
            department_id,
            team_id,
            member_id,
            officeData,
            departmentsData,
            teamsData,
            membersData,

            viewOffice,
            viewDept,
            viewTeam,
            viewMember,
        } = this.state;
        const { isDisabled, editable, justTeam } = this.props;
        const showOffice = () => {
            if (roleName === ADMIN) {
                return <TextField
                    disabled={isDisabled}
                    id="office"
                    select
                    label="Office"
                    className="textField"
                    value={office}
                    onChange={e => this.handleSelect(e, "office")}
                    margin="dense"
                    variant="outlined"
                >
                    {officeData.map((value, index) => (
                        <MenuItem key={index} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                </TextField>
            } else {
                return <TextField
                    disabled={isDisabled}
                    id="office"
                    select
                    label="Office"
                    className="textField"
                    value={office}
                    onChange={e => this.handleSelect(e, "office")}
                    margin="dense"
                    variant="outlined"
                >
                    {officeData.map((value, index) => (
                        <MenuItem key={index} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const showDepartment = () => {
            if (office) {
                return <TextField
                    disabled={isDisabled}
                    id="department"
                    select
                    label="Department"
                    className="textField"
                    value={department_id}
                    onChange={e => this.handleSelect(e, "department_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {departmentsData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const showTeam = () => {
            if (department_id) {
                return <TextField
                    disabled={isDisabled}
                    id="team"
                    select
                    label="Team"
                    className="textField"
                    value={team_id}
                    onChange={e => this.handleSelect(e, "team_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {teamsData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const showMembers = () => {
            if (team_id && justTeam === false) {
                return <TextField
                    disabled={isDisabled}
                    id="member"
                    select
                    label="Member"
                    className="textField"
                    value={member_id}
                    onChange={e => this.handleSelect(e, "member_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {(membersData || []).map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {(option.first_name ? option.first_name : "") + " " + (option.last_name ? option.last_name : "") + " - " + option.email + "-" + option.phone}
                        </MenuItem>
                    ))}
                </TextField>
            }
        }
        const addOrEditView = () => {
            if (editable === false) {//view
                return <div className="levelWapper">
                    <TextField
                        disabled={true}
                        className="textField"
                        label="Office"
                        value={viewOffice}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={true}
                        className="textField"
                        label="Department"
                        value={viewDept}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={true}
                        className="textField"
                        label="Team"
                        value={viewTeam}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={true}
                        className="textField"
                        label="Member"
                        value={viewMember}
                        margin="dense"
                        variant="outlined"
                    />
                </div>
            } else {//edit
                return <div className="levelWapper">
                    {showOffice()}
                    {showDepartment()}
                    {showTeam()}
                    {showMembers()}
                </div>
            }
        }
        return (
            <Root>
                {addOrEditView()}
            </Root>
        )
    }
    //1.dept:提取账号所在的office/dept        team/member调用接口
    //2.team:提取账号所在的office/dept/team   member调用接口
    //3.user:提取账号所在的office/dept/team   member调用接口
    componentDidMount() {
        if (roleName === ADMIN) {
            this.getOfficeAdmin(() => {
                this.initData();
            });
        } else {
            this.getOffice(() => {
                this.initData();
            });
        }
    }
    initData() {
        const {
            state,
            officeName,
            deptId,
            teamId,
            memberId,
            editable,
            viewData,
        } = this.props;
        if (!editable) {
            const teamObj = viewData ? viewData.team : "";
            const userObj = viewData ? viewData.user : "";
            const viewOffice = teamObj ? teamObj.dept_info.office : "";
            const viewDept = teamObj ? teamObj.dept_info.name : "";
            const viewTeam = teamObj ? teamObj.name : "";
            const viewMember = userObj ? userObj.first_name + " " + userObj.last_name : "";
            const team_id = teamObj ? teamObj.id : "";
            const member_id = userObj ? userObj.id : "";
            const department_id = teamObj ? teamObj.dept_info.id : "";
            this.setState(() => ({
                viewOffice,
                viewDept,
                viewTeam,
                viewMember,
                team_id,
                member_id,
                department_id,
            }))
        } else if (state === VIEW || state === EDIT) {
            const office = officeName ? officeName : "";
            const department_id = deptId ? deptId : "";
            const team_id = teamId ? teamId : "";
            const member_id = memberId ? memberId : "";
            this.setNextData("office", office, () => {
                this.setState({
                    office,
                    department_id
                }, () => {
                    this.setNextData("department_id", department_id, () => {
                        this.setState({
                            team_id,
                        }, () => {
                            this.setNextData("team_id", team_id, () => {
                                this.setState(() => ({
                                    member_id
                                }));
                            })
                        });
                    })
                })
            })
        }
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setNextData(name, value);
        this.setState(() => ({
            [name]: value
        }))
    }
    setNextData(name, value, callback = null) {
        if (name === "office") {
            this.clearSelectData("department");
            if (roleName === ADMIN) {
                this.getDepartmentsAdmin(value, () => {
                    if (callback) callback();
                })
            } else {
                this.getDepartments(value, () => {
                    if (callback) callback();
                })
            }
        } else if (name === "department_id") {
            //1.清理team数据 2.根据dept的name在整个data中查找dept的obj 3.根据deptid获取team
            this.clearSelectData("team");
            if (roleName === ADMIN) {
                this.getTeamsAdmin(value, () => {
                    if (callback) callback();
                });
            } else {
                this.getTeams(value, () => {
                    if (callback) callback();
                });
            }
        } else if (name === "team_id") {
            //1.清理member数据 2.根据选择的team筛选出member数据
            this.clearSelectData("member");
            this.getMembersAdmin(value, () => {
                if (callback) callback();
            });
        }
    }
    clearSelectData(name) {
        if (name === "team") {
            this.setState(() => ({
                team_id: "",
                teamsData: [],
                member_id: "",
                membersData: []
            }))
        } else if (name === "department") {
            this.setState(() => ({
                department_id: "",
                team_id: "",
                teamsData: [],
                member_id: "",
                membersData: []
            }))
        } else if (name === "member") {
            this.setState(() => ({
                member_id: "",
                membersData: []
            }))
        }
    }
    getData() {
        const {
            department_id,
            member_id,
            team_id,
        } = this.state;
        const handler_id = member_id;
        const handler_team_id = team_id;
        const handler_department_id = department_id;
        const obj = {
            handler_id,
            handler_team_id,
            handler_department_id
        }
        return obj;
    }
    //-----------request--------------
    getOfficeAdmin(callback) {
        instance.get(BASE_URL + 'admin/departments/office').then((res) => {
            let officeData = res.data.data;
            console.log("admin office", officeData);
            this.setState({
                officeData
            }, () => {
                callback();
            })
        })
    }
    getOffice(callback) {
        instance.get(BASE_URL + 'common/departments/office').then((res) => {
            let officeData = res.data.data;
            console.log("office", officeData);
            this.setState({
                officeData
            }, () => {
                callback();
            })
        })
    }
    getDepartmentsAdmin(office, callback) {
        const params = {
            office,
        }
        instance.get(BASE_URL + 'admin/departments', { params }).then((res) => {
            let departmentsData = res.data.data;
            console.log("admin dept", departmentsData);
            this.setState({
                departmentsData,
            }, () => {
                callback();
            })
        })
    }
    getDepartments(office, callback) {
        const params = {
            office,
        }
        instance.get(BASE_URL + 'common/departments', { params }).then((res) => {
            let departmentsData = res.data.data;
            console.log("dept", departmentsData);
            this.setState({
                departmentsData,
            }, () => {
                callback();
            })
        })
    }
    getTeamsAdmin(dept_id, callback) {
        instance.get(BASE_URL + `admin/departments/${dept_id}/teams`).then((res) => {
            let teamsData = res.data.data;
            console.log("admin teams", teamsData);
            this.setState({
                teamsData
            }, () => {
                callback();
            })
        })
    }
    getTeams(dept_id, callback) {
        instance.get(BASE_URL + `common/departments/${dept_id}/teams`).then((res) => {
            let teamsData = res.data.data;
            console.log("team", teamsData);
            this.setState({
                teamsData
            }, () => {
                callback();
            })
        })
    }
    getMembersAdmin(team_id, callback) {
        instance.get(BASE_URL + `common/teams/${team_id}/members`).then((res) => {
            let membersData = res.data.data.members;
            console.log("member", membersData);
            this.setState({
                membersData
            }, () => {
                callback();
            })
        })
    }
}

export default LevelChoose;